import { useQuery } from "@apollo/client";

import {
  CustomerServiceOrganizationAccountsDocument,
  type CustomerServiceOrganizationAccountsQuery,
} from "../generated/graphql";

// The Salesforce account a facility is linked to; undefined while loading.
export const useOrganizationAccount = (
  organizationId: string
): { salesforceAccountId: string | null; salesforceAccountName: string | null } | undefined => {
  const { data } = useQuery<CustomerServiceOrganizationAccountsQuery>(CustomerServiceOrganizationAccountsDocument, {
    fetchPolicy: "cache-and-network",
  });
  if (!data) return undefined;
  const organization = data.customerServiceOrganizationAccounts.find(row => row.organizationId === organizationId);
  return {
    salesforceAccountId: organization?.salesforceAccountId ?? null,
    salesforceAccountName: organization?.salesforceAccountName ?? null,
  };
};
